<template>
    <a :href="url" :title="title" class="fancybox image widget_picture" rel="fancybox" :style="{ width: width, height: 'auto' }">
        <img :src="url" :alt="title" style="border: 1px solid grey" />
        <span class="su-custom-gallery-title">{{ title }}</span>
        <div v-if="!url">Атрибут url не указан</div>
        <div v-if="!title">Атрибут title не указан</div>
    </a>
</template>

<script>
export default {
    name: "Picture",
    props: ["url", "title", "width", "height"],
};
</script>

<style scoped>
.widget_picture {
    margin: auto;
}

.widget_picture > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>
